import DropdownForm from "../../Form/DropdownForm";
import { Field } from "formik";

const CoursesInPackage = ({
  errors,
  touched,
  setFieldValue,
  handleChange,
  courses,
  index,
  values,
}) => {
  const selectedCourseIds = values.courses
    ?.map((c) => String(c.course_name))
    .filter(Boolean);

  const selectedCourse = courses?.find(
    (course) =>
      course.id.toString() === values.courses?.[index]?.course_name?.toString()
  );

  const availableCourses = courses?.filter(
    (course) =>
      !selectedCourseIds?.includes(course.id?.toString()) ||
      course?.id === selectedCourse?.id
  );

  const handleChangeCourse = (e) => {
    const selectedId = +e.target.value;

    const selectedCourse = courses.find((c) => c.id === selectedId);

    console.log(selectedCourse);

    if (selectedCourse) {
      setFieldValue(`courses.${index}.course_name`, selectedCourse.id);
      setFieldValue(
        `courses.${index}.course_price`,
        selectedCourse.e_money || 0
      );
      setFieldValue(`courses.${index}.pv_upliner`, selectedCourse.weight || 0);
    }
  };

  return (
    <>
      {/* course name */}
      <DropdownForm
        handleChange={handleChange}
        name={`courses.${index}.course_name`}
        dataToDrop={availableCourses}
        error={errors?.[`courses.${index}.course_name`]}
        touched={touched?.[`courses.${index}.course_name`]}
        label="Course Name"
        placeholder="Select a course"
        gridStyle="col-sm-12 col-md-4"
        onChange={handleChangeCourse}
        labelKey="course_name_en"
        value={values?.courses?.[index]?.course_name || ""}
      />

      {/* course Price */}
      <div className="col-md-4 mb-3">
        <label
          className="form-label required-label"
          htmlFor={`courses.${index}.course_price`}
        >
          Course Price
        </label>
        <Field
          className={`form-control ${
            touched[`courses.${index}.course_price`] &&
            errors[`courses.${index}.course_price`]
              ? "custom-invalid-input"
              : ""
          }`}
          name={`courses.${index}.course_price`}
          placeholder="Course price"
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "");
            setFieldValue(`courses.${index}.course_price`, numericValue);
          }}
        />
      </div>

      {/* PV Upliner */}
      <div className="col-md-4 mb-3">
        <label
          className="form-label required-label"
          htmlFor={`courses.${index}.course_price`}
        >
          PV Upliner
        </label>
        <Field
          className={`form-control ${
            touched[`courses.${index}.pv_upliner`] &&
            errors[`courses.${index}.pv_upliner`]
              ? "custom-invalid-input"
              : ""
          }`}
          name={`courses.${index}.pv_upliner`}
          placeholder="PV Upliner"
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "");
            setFieldValue(`courses.${index}.pv_upliner`, numericValue);
          }}
        />
      </div>
    </>
  );
};

export default CoursesInPackage;
